import React from 'react';
import { Box } from '@chakra-ui/react';

const TooltipKeyBox: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    as="span"
    px={2}
    py={0.5}
    bg="gray.700"
    borderRadius="md"
    fontSize="sm"
    border="1px solid"
    borderColor="gray.500"
    display="inline-flex"
    alignItems="center"
    justifyContent="center"
    minW="24px"
    h="24px"
    color="gray.100"
    fontWeight="medium"
    _hover={{ bg: 'gray.600' }}
  >
    {children}
  </Box>
);

export default TooltipKeyBox; 